import { Cancel } from "@mui/icons-material";
import { GridActionsCellItem, GridRowModes } from "@mui/x-data-grid";

export default function CancelButton({ rowID, setRowModesModel }) {
  const handleClick = () =>
    setRowModesModel((rowModesModel) => {
      return {
        ...rowModesModel,
        [rowID]: { mode: GridRowModes.View, ignoreModifications: true },
      };
    });

  return (
    <GridActionsCellItem
      icon={<Cancel />}
      label={"Cancel"}
      onClick={handleClick}
    />
  );
}
